<template>
    <component :is="getIconForTransportMode(mode)"/>
</template>

<script>
import IconList from '@/components/icons/IconList.vue'
import IconCar from '@/components/icons/IconCar.vue'
import IconTrain from '@/components/icons/IconTrain.vue'
import IconMotorcycle from '@/components/icons/IconMotorcycle.vue'
import IconWalk from '@/components/icons/IconWalk.vue'
import IconBike from '@/components/icons/IconBike.vue'
import IconParkAndRide from '@/components/icons/IconParkAndRide.vue'
import IconBikeAndRide from '@/components/icons/IconBikeAndRide.vue'
import IconCamper from '@/components/icons/IconCamper.vue'
import IconDrawingVehicle from '@/components/icons/IconDrawingVehicle.vue'
import IconSharing from '@/components/icons/IconSharing.vue'
import IconBikeSharing from '@/components/icons/IconBikeSharing.vue'
import IconCarTrain from '@/components/icons/IconCarTrain.vue'
export default {
    props: {
        mode: {
            type: String,
            default: ''
        }
    },
    components: {
        IconList,
        IconCar,
        IconTrain,
        IconMotorcycle,
        IconWalk,
        IconBike,
        IconParkAndRide,
        IconBikeAndRide,
        IconCamper,
        IconDrawingVehicle,
        IconSharing,
        IconBikeSharing,
        IconCarTrain,
    },
    methods: {
        getIconForTransportMode(mode) {
            let icon = false;
            const icons = {
                'LIST': 'List',
                'CAR': 'Car',
                'PUBLIC': 'Train',
                'FOOT': 'Walk',
                'BIKE': 'Bike',
                'MOTORCYCLE': 'Motorcycle',
                'PARK_AND_RIDE': 'ParkAndRide',
                'BIKE_AND_RIDE': 'BikeAndRide',
                'CAMPER': 'Camper',
                'TRAILER': 'DrawingVehicle',
                'SHARING': 'Sharing',
                'BIKE_SHARING': 'BikeSharing',
                'CAR_TRAIN': 'CarTrain'
            }
            if(icons[mode]){
                icon = 'Icon' + icons[mode];
            }
            return icon;
        },
    }
}
</script>